import { computed } from '@nuxtjs/composition-api'
import { Location } from 'vue-router'
import { useWebNode } from '~/composables/useWebNode'
import { ContentPart, Menu } from '~/types/content'
import { useContent } from '~/composables/useContent'

const BRAND_CATEGORY_CODE = '1'
export const MenuPaths = new Map<string, Location>([
  ['merken', { name: 'brand' }],
])
export const useMenu = () => {
  const { root, loading } = useWebNode()

  const { menus } = useContent()

  const mainMenu = computed(
    () => (menus.value?.[ContentPart.MainMenu] ?? []) as Menu[]
  )

  const topMenu = computed(() => menus.value?.[ContentPart.TopMenu] ?? [])

  const footerMenu = computed(() => menus.value?.[ContentPart.FooterMenu] ?? [])

  const categories = computed(() => {
    return (
      root.value?.children?.filter(
        (item) => item.code !== BRAND_CATEGORY_CODE
      ) ?? []
    )
  })

  return {
    root,
    loading,
    categories,
    mainMenu,
    topMenu,
    footerMenu,
  }
}
